/**
 * Форматирование денежных значений в рублях.
 */
export function formatRub(value) {
  const amount = Math.round((Number(value) || 0) * 100) / 100;
  const hasKopecks = Math.round(amount * 100) % 100 !== 0;

  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: hasKopecks ? 2 : 0,
    maximumFractionDigits: hasKopecks ? 2 : 0,
  }).format(amount);
}
